import { render, staticRenderFns } from "./Equip.vue?vue&type=template&id=5490b7af&scoped=true"
import script from "./Equip.vue?vue&type=script&lang=js"
export * from "./Equip.vue?vue&type=script&lang=js"
import style0 from "./Equip.vue?vue&type=style&index=0&id=5490b7af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5490b7af",
  null
  
)

export default component.exports